import { useEffect, useState } from 'react';
import { ExoGant } from './ExoGant';
import { DBRequest, useConfig } from '../../api/api';
import Cookies from 'universal-cookie';
import moment from 'moment';

export const ExoUserGant = ({ userId }) => {
  const config = useConfig();
  const cookies = new Cookies();
  const loggedInUserId = cookies.get('userId');

  const [apiData, setApiData] = useState(null);

  useEffect(() => {
    DBRequest({
      config,
      path: `users/${userId || loggedInUserId}/project-phases/work-packages`,
      onResponse: handleResponse,
    });
  }, [loggedInUserId, userId, config]);

  function handleResponse(res) {
    const projectPhaseMap = {};
    res.data.forEach((phase) => {
      const { name, project, workPackages } = phase;
      if (!project) return;

      // create element init
      if (!projectPhaseMap[project.id])
        projectPhaseMap[project.id] = {
          id: project.id,
          name: (
            <>
              <span className="monospace opacity-50">{project.nr}</span>{' '}
              {project.name}
            </>
          ),
          image: project.image,
          workPackages: [],
          heat: 0,
        };

      workPackages.forEach((wp) => {
        projectPhaseMap[project.id].workPackages.push({
          ...wp,
          subTitle: name,
          project,
        });
      });
      // calc heat level 0-10
      const heat = calculateHeatLevel(projectPhaseMap[project.id].workPackages);
      projectPhaseMap[project.id].heat = heat;
    });

    // format into phases
    const newPhases = [];
    Object.keys(projectPhaseMap).forEach((key) => {
      newPhases.push(projectPhaseMap[key]);
    });
    // Sort by heat level descending
    const sortedPhases = [...newPhases].sort((a, b) => b.heat - a.heat);
    setApiData({ ...res, data: sortedPhases });
  }

  function calculateHeatLevel(workPackages) {
    const now = moment();
    const running = workPackages.filter((wp) => wp.status === 0);

    if (running.length === 0) return 0;

    let totalHeat = 0;

    running.forEach((wp) => {
      const start = moment(wp.startDate);
      const end = wp.endDate ? moment(wp.endDate) : null;

      if (start.isAfter(now)) {
        // Future package
        totalHeat += 0;
      } else if (end && now.isAfter(end)) {
        // Overdue package
        totalHeat += 10;
      } else if (end) {
        // Running package, scale heat 0–10 based on progress
        const duration = end.diff(start);
        const elapsed = now.diff(start);
        const heat = Math.max(0, Math.min(10, 10 * (elapsed / duration)));
        totalHeat += heat;
      } else {
        // Ongoing without endDate, treat as medium heat
        totalHeat += 5;
      }
    });

    // Average heat over all running packages
    const heatLevel = totalHeat / running.length;

    return Math.round(heatLevel);
  }

  return <ExoGant ownData={apiData} useOwnData startAllowedStatuses={[0]} />;
};
